import { APIRequest } from '@reverbdotcom/discovery-ui';

window.Reverb = window.Reverb || {};
Reverb.AjaxPaginationHandler = (function () {
  function bindRemotePagination() {
    $(document).on('click', '.remote-pagination-container .pagination a', function (e) {
      e.preventDefault();

      if (isDisabled(e.target)) {
        return;
      }

      const containerSelector = '.remote-pagination-container';
      let $container = $(containerSelector);
      const updatingContainerClass = $container.data('updating-container-class');
      const url = $(this).prop('href');

      if (updatingContainerClass) {
        $container.spin();
        $container.addClass(updatingContainerClass);
      }

      $('html, body').animate({ scrollTop: 0 }, 400);

      APIRequest.get(url).done((html) => {
        $container.replaceWith(html);

        $container = $(containerSelector); // we find the container again because it's been replaced
        if ($container.data('replace-state') !== undefined) {
          history.replaceState({}, document.title, url);
        }

        $container.trigger('reverb.ajax_load.complete');
      });
    });
  }

  function isDisabled(element) {
    return element.classList.contains('disabled') || element.parentNode.classList.contains('disabled');
  }

  function init() {
    bindRemotePagination();
  }

  return {
    init,
  };
}());

$(Reverb.AjaxPaginationHandler.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/ajax_pagination.js